import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_037.jpg';
page.images = [
  {
    imageId: 'page037_zoom0',
    rectangle: {
      x: 600,
      y: 1522,
      width: 1196,
      height: 696,
    },
    imageSrc: 'images/page037/037 3.jpg',
  },
  {
    imageId: 'page037_zoom1',
    rectangle: {
      x: 602,
      y: 748,
      width: 1182,
      height: 676,
    },
    imageSrc: 'images/page037/037 2.jpg',
  },
  {
    imageId: 'page037_zoom2',
    rectangle: {
      x: 602,
      y: 292,
      width: 1184,
      height: 436,
    },
    imageSrc: 'images/page037/037 1.jpg',
  },
];

page.games = [
  {
    id: 'page037_game12',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1719,
    },
    item: {
      id: 'page037_game12',
    },
    rectangle: {
      id: 'page037_rect2',
    },
  },
  {
    id: 'page037_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 774,
    },
    item: {
      id: 'page037_game11',
    },
    rectangle: {
      id: 'page037_rect1',
    },
  },
  {
    id: 'page037_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 266,
    },
    item: {
      id: 'page037_game10',
    },
    rectangle: {
      id: 'page037_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page037_rect0',

    tooltip: '',

    linked: ['page037_game10'],
    x: 137,
    y: 266,
    width: 462,
    height: 501,
  },
  {
    id: 'page037_rect1',

    tooltip: '',

    linked: ['page037_game11'],
    x: 134,
    y: 774,
    width: 464,
    height: 563,
  },
  {
    id: 'page037_rect2',

    tooltip: '',

    linked: ['page037_game12'],
    x: 132,
    y: 1719,
    width: 455,
    height: 510,
  },
];
export default page;
